import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/** shadcn's canonical class-merging helper. Takes variadic class-name inputs
 * (strings, arrays, objects) and de-duplicates conflicting Tailwind classes. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
